export default __webpack_public_path__ + "static/media/parents_arknote@2x.24720476.png";